<template lang="pug">
  .carousel(:style="{ height: carouselHeight }")
    slot
    .slide-link-wrapper
      .slide-link(@click="setCurrentSlide(index)" v-for="(slide, index) in slides" :class="[index === currentSlide ? 'active' : '']")
</template>

<script>
import Hammer from 'hammerjs'

export default {
  name: 'carousel',
  props: {
    carouselHeight: {},
  },
  data () {
    return {
      currentSlide: 0,
      slides: [],
    }
  },
  mounted () {
    this.$children.forEach(element => this.slides.push(element))
    this.setCurrentSlide(0)

    this.hammertime = new Hammer(this.$el);

    this.hammertime.on('swipeleft', (e) => { this.swipeListener(e.direction) } )
    this.hammertime.on('swiperight', (e) => { this.swipeListener(e.direction) } )
  },
  methods: {
    setCurrentSlide (index) {
      this.currentSlide = index
      this.$children.forEach(child => child.setInactive())
      this.$children[index].setActive()
    },
    swipeListener (direction) {
      if (direction === 4 && this.currentSlide > 0) {
        this.setCurrentSlide(this.currentSlide - 1)
      } else if ( direction === 2 && this.currentSlide < this.slides.length - 1 ) {
        this.setCurrentSlide(this.currentSlide + 1)
      }
    }
  },
  components: {
  },
}
</script>

<style scoped lang="scss">
.carousel {
  position: relative;
  overflow: hidden;

  .slide-link-wrapper {
    position: absolute;
    bottom: 2rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 3;
  }

  .slide-link {
    display: inline-block;
    width: 5.3rem;
    height: .6rem;
    background: white;
    margin: 2rem 5rem 2rem 0;
    transition: background .15s ease-in;

    &:last-of-type {
      margin-right: 0;
    }

    &:hover,
    &.active {
      background: black;
    }
  }

  @media #{$mobile} {
    .slide-link {
      width: 6rem;
      height: 1rem;
    }
  }
}
</style>
